module.exports = __webpack_public_path__ + "img/diagram-lean-canvas.4f104a63.svg";